// Real clips (generated by the user via Hailuo, an AI video tool — not
// pre-rendered by this codebase) live in src/Assets/Videos and are
// imported as bundled assets, the same convention every other image in
// this project already uses (see hero-portrait.png in HeroGlass.js).
// No webm/poster yet — these are the raw MP4s as generated, not run
// through scripts/encode-avatar.sh (no ffmpeg available in this
// session to do the ping-pong seamless-loop pass or AV1 encode/poster
// extraction). `<video loop>` still works fine on a raw clip; it just
// jump-cuts at the loop point instead of looping seamlessly.
import idleMp4 from "../Assets/Videos/idle.mp4";
import listeningMp4 from "../Assets/Videos/listening.mp4";
import thinkingMp4 from "../Assets/Videos/thinking.mp4";
import reasoningMp4 from "../Assets/Videos/reasoning.mp4";
import speakingMp4 from "../Assets/Videos/speaking.mp4";
import completeMp4 from "../Assets/Videos/complete.mp4";

export const AVATAR_STATES = ["idle", "listening", "thinking", "reasoning", "speaking", "complete"];

const MP4_BY_STATE = {
  idle: idleMp4,
  listening: listeningMp4,
  thinking: thinkingMp4,
  reasoning: reasoningMp4,
  speaking: speakingMp4,
  complete: completeMp4,
};

export function avatarAsset(state) {
  const mp4 = MP4_BY_STATE[state] || MP4_BY_STATE.idle;
  // No webm or poster yet — VideoAvatar/AvatarStage both already handle
  // a missing poster/webm gracefully (poster just means a blank frame
  // until decode; webm absence means VideoAvatar always picks mp4).
  return { webm: null, mp4, poster: null };
}

export const PRELOAD_STATE = "idle";
export const PREFETCH_STATES = AVATAR_STATES.filter((s) => s !== PRELOAD_STATE);
